import apis from "../../core/apis.js";

class FineReimbursementResource {
  constructor($resource) {
    "ngInject";

    this.$resource = $resource;
  }

  getAll(options) {
    return this.$resource(apis.fineReimbursement).get(options);
  }

  get(id) {
    return this.$resource(apis.fineReimbursement + id).get();
  }

  search(search = "") {
    return this.$resource(apis.fineReimbursement).get({ search });
  }

  post(item) {
    return this.$resource(apis.fineReimbursement).save(item);
  }

  update(id, item) {
    return this.$resource(apis.fineReimbursement + id, null, {
      update: { method: "PATCH" },
    }).update(item);
  }

  getReasons(params) {
    return this.$resource(apis.fineReimbursement + "reasons", null, {
      get: { isArray: true },
    }).get(params);
  }

  postDecision(id, decision, body) {
    return this.$resource(`${apis.fineReimbursement}${id}/${decision}`).save(
      body
    );
  }
}

export default FineReimbursementResource;



// WEBPACK FOOTER //
// ./src/resources/fineReimbursement/fineReimbursement.resource.js